import { type ReactNode } from "react";
import { Modal as MantineModal } from "@mantine/core";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

export function Modal({ isOpen, onClose, title, children, size = "md" }: ModalProps) {
  return (
    <MantineModal
      opened={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      centered
      styles={{
        header: { backgroundColor: "#16213e" },
        body: { backgroundColor: "#16213e" },
        content: { backgroundColor: "#16213e" },
      }}
    >
      {children}
    </MantineModal>
  );
}
